// Careers page does not need translations
const CAREERS_STRINGS = {
  CAREERS: 'Careers',
  CAREERS_AT_ALLTRAILS: 'Careers at AllTrails',
  HELP_KINDLE: 'Help us kindle the spirit of adventure',
  CAREERS_HERO_ALT: 'A person looking over Yosemite at sunrise',
  NAV: {
    ABOUT_ALLTRAILS: 'About AllTrails',
    OUR_BENEFITS: 'Our benefits',
    OPEN_POSITIONS: 'Open positions',
    BROWSE_POSITIONS: 'Browse open positions'
  }
};

export default CAREERS_STRINGS;
